import type { ZodIssue } from "zod";

export const processIssues = (issues: ZodIssue[]) => {
  return issues.reduce((acc: Record<string, string>, issue) => {
    const {
      path: [key],
      message
    } = issue;
    return acc[key] ? acc : { ...acc, [key]: message };
  }, {});
};
